import '@fontsource-variable/dm-sans';
// style mapy globalnie — AreaMap bywa w osobnym, doczytywanym pliku (hero), a jego CSS musi być na każdej stronie z mapą
import 'maplibre-gl/dist/maplibre-gl.css';
import './styles.css';
import { use, useState, type ReactNode } from 'react';
import {
  isRouteErrorResponse,
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  type LinksFunction,
  type MetaFunction,
} from 'react-router';
import { Providers } from './app/providers';
import { createQueryClient } from './app/queryClient';
import { NonceContext } from './shared/seo/nonce';
import { siteSettings, type SiteSettings } from './shared/seo/seo';

/** Ustawienia SEO z zmiennych środowiskowych serwera SSR (RYNEK_SITE_URL, RYNEK_INDEXING). */
export function loader(): { site: SiteSettings } {
  return { site: siteSettings(process.env) };
}

export const meta: MetaFunction = () => [
  { title: 'Rynek. — ogłoszenia nieruchomości' },
  { name: 'description', content: 'Ogłoszenia nieruchomości w Polsce. Najpierw miejsce, potem mieszkanie.' },
];

export const links: LinksFunction = () => [
  { rel: 'icon', type: 'image/svg+xml', href: '/favicon.svg' },
  { rel: 'apple-touch-icon', href: '/apple-touch-icon.png' },
  // aplikacja na ekranie głównym (na iPhonie warunek powiadomień push)
  { rel: 'manifest', href: '/manifest.webmanifest' },
];

/** Dokument HTML wspólny dla SSR i przeglądarki. */
export function Layout({ children }: { children: ReactNode }) {
  const nonce = use(NonceContext);
  return (
    <html lang="pl">
      <head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="theme-color" content="#222222" />
        <Meta />
        <Links />
      </head>
      <body>
        {children}
        <ScrollRestoration {...(nonce ? { nonce } : {})} />
        <Scripts {...(nonce ? { nonce } : {})} />
      </body>
    </html>
  );
}

export default function App() {
  // osobna pamięć zapytań na każde żądanie SSR i na kartę przeglądarki
  const [queryClient] = useState(createQueryClient);
  return (
    <Providers queryClient={queryClient}>
      <Outlet />
    </Providers>
  );
}

export function ErrorBoundary({ error }: { error: unknown }) {
  const status = isRouteErrorResponse(error) ? error.status : 500;
  return (
    <main className="mx-auto max-w-3xl px-4 py-16 sm:px-6">
      <div className="eyebrow">Błąd {status}</div>
      <h1 className="mt-2 text-4xl">{status === 404 ? 'Nie ma takiej strony.' : 'Coś poszło nie tak.'}</h1>
      <p className="text-ink-2 mt-4">
        {status === 404 ? 'Adres mógł się zmienić.' : 'Spróbuj odświeżyć stronę za chwilę.'}
      </p>
      <a href="/" className="btn btn-outline mt-8">
        Wróć na stronę główną
      </a>
    </main>
  );
}
